import React from 'react';
import {Link} from 'react-router-dom'
import { Navbar } from './Navbar'
import { Footer } from './Footer'

export class MemberLayoutHoc extends React.Component{
    render(){
        return (
            <div>
               <Navbar />
                    {this.props.children}
                <Footer/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_components/MemberLayoutHoc.jsx